import React, { useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario";

const DescargarAusenciasEscuela = () => {

  const [escuela, setEscuela] = useState("");

  const Usuario = ObtieneDatosCookies();

  const escuelas = [
    "Escuela de Policia",
    "Escuela de Especialidades",
    "Escuela Superior",
    "Escuela de Investigaciones",
    "Educacion a Distancia",
    "Extracurricular",
    "Extension Comunitaria"
  ];

  // 🔐 convertir permisos a array
  const permisos = Usuario?.funcion
    ? Usuario.funcion.split(",").map((p) => p.trim())
    : [];

  // 🔎 filtrar escuelas permitidas
  const escuelasPermitidas = escuelas.filter((esc) =>
    permisos.includes(esc)
  );

  const descargarExcel = async () => {

    if (!escuela) {
      alert("Seleccione una escuela");
      return;
    }

    try {

      const response = await axios.post(
        "https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/getAusentesHistoricoPorEscuela",
        { escuela }
      );

      const data = response.data;

      if (!data.ok || !data.cursos) {
        alert("No hay datos para descargar");
        return;
      }

      const workbook = XLSX.utils.book_new();
      const resumen = [];

      Object.values(data.cursos).forEach((curso) => {

        if (!curso.ausencias || curso.ausencias.length === 0) return;

        const nombreCurso = curso.nombreCurso || `Curso ${curso.cursoId}`;

        resumen.push({
          Curso_ID: curso.cursoId,
          Curso: nombreCurso,
          Total_Ausencias: curso.totalAusencias
        });

        const filas = curso.ausencias.map((a) => ({
          Curso_ID: curso.cursoId,
          Curso: nombreCurso,
          DNI: a.dni,
          Apellido: a.apellido,
          Nombres: a.nombres,
          Fecha: a.fecha,
          División: a.division,
          Observación: a.observacion,
          Fecha_Parte: a.fechaHoraParte,
          Usuario: a.usuarioSigedi
        }));

        const worksheet = XLSX.utils.json_to_sheet(filas);

        let nombreHoja = `${curso.cursoId}-${nombreCurso}`
          .replace(/[\\/?*[\]]/g, "")
          .substring(0, 31);

        XLSX.utils.book_append_sheet(
          workbook,
          worksheet,
          nombreHoja
        );

      });

      resumen.sort((a, b) => b.Total_Ausencias - a.Total_Ausencias);

      const resumenSheet = XLSX.utils.json_to_sheet(resumen);

      XLSX.utils.book_append_sheet(
        workbook,
        resumenSheet,
        "RESUMEN"
      );

      // mover resumen al inicio
      workbook.SheetNames.unshift(
        workbook.SheetNames.pop()
      );

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const blob = new Blob([excelBuffer], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, `Informe_Inasistencias_${escuela}.xlsx`);

    } catch (error) {

      console.error(error);
      alert("Error al generar el informe");

    }
  };

  return (
    <div style={{ textAlign: "center", marginTop: "40px" }}>

      <h3>Informe de Inasistencias por Escuela</h3>

      <select
        value={escuela}
        onChange={(e) => setEscuela(e.target.value)}
        style={{
          padding: "8px",
          fontSize: "16px",
          marginRight: "10px"
        }}
      >

        <option value="">Seleccione una escuela</option>

        {escuelasPermitidas.map((esc) => (
          <option key={esc} value={esc}>
            {esc}
          </option>
        ))}

      </select>

      <button
        onClick={descargarExcel}
        style={{
          padding: "10px 20px",
          fontSize: "16px",
          backgroundColor: "#1f618d",
          color: "white",
          border: "none",
          borderRadius: "6px",
          cursor: "pointer",
          fontWeight: "bold"
        }}
      >
        📊 Descargar informe
      </button>

    </div>
  );
};

export default DescargarAusenciasEscuela;